<template>
  <form action="" id="liveRegistrationFormModal">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">画像のアップロード</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <b-upload @input="updateValue" drag-drop expanded>
          <div class="content has-text-centered preview__upload">
            <b-icon icon="upload" size="is-large" />
            <p>クリックするか、画像をドラッグアンドドロップしてください。</p>
          </div>
        </b-upload>
      </section>
    </div>
  </form>
</template>

<script>
export default {
  name: 'IconUploadModal',
  props: ['value'],
  methods: {
    updateValue(value) {
      this.$emit('uploaded', value);
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped></style>
